/**
 * Contains application specific configuration items, which is exported and passed to components
 */

const AppConfig = {
  routePaths: {
    login: "/login",
    logout: "/logout",
    home: "/home",
    details: "/details",
    glossary: "/glossary",
    whatsNew: "/whatsNew",
    newJoiner: "/newJoiner",
    results: "/results",
    compare: "/compare",
    recentlyViewAll: "/recentlyViewAll",
    ClientData: "/ClientData",
    detailsCD: "/detailsCD",
    resultsCD: "/resultsCD",
  },
  actionPanel: {
    "toastTimeOut": 3000,
    "shareToTeamsUrl": "https://teams.microsoft.com/share?href=%APP_URL%"
  },
  collateralDetails: {
    fileFormatIcon: [
      {
        type: "excel",
        values: ['xls', 'xlsx', 'csv']
      },
      {
        type: "word",
        values: ['doc', 'docx']
      },
      {
        type: "ppt",
        values: ['ppt', 'pptx']
      },
      {
        type: "pdf",
        values: ['pdf']
      }
    ]
  },
  resultPage: {
    sortList: ["Relevance", "Popularity", "Title"],
    defaultSortOrder: {
      relevance: {
        sortList: [],
        value: "Relevance"
      },
      popularity: {
        sortList: [{property: "EYKDViewCount", direction: 1}],
        value: "Popularity"
      },

      /* date: {
        sortList: [{ property: "EYKDLastUpdatedDate", direction: 1 }],
        value: "Date"
      }, */
      title: {
        sortList: [{property: "EYKDTitle", direction: 0}],
        value: "Title"
      },
      topic: {
        sortList: [{property: "EYKDSortOrder", direction: 0}],
        value: "Title"
      }
    },
    resultTitle: {
      essentials: "Essentials {count} result(s)",
      mostpopular: "Most Popular {count} result(s)",
      searchTitle: "{count} result(s)"
    },
    dataProviderHoverImageURL: "/assets/images/Data%20Provider/Data-Provider-Logo_Yellow_Hover.jpg"
  },
  metaData:
  {
    title: "",
    sectionType: "data_table",
    subSections: {
      left: [
        {
          title: "Topic",
          displayProperty: "EYKDTopics"
        },
        {
          title: "Category",
          displayProperty: "owstaxIdEYKDCategory",
          id: "dataCategory",
          dataType: "taxonomy"
        },
        {
          title: "Sector",
          displayProperty: "owstaxIdEYKDSector",
          id: "sector",
          dataType: "taxonomy"
        },
        {
          title: "Service Line",
          displayProperty: "owstaxIdEYKDServiceLine",
          id: "serviceLine",
          dataType: "taxonomy"
        },
        {
          title: "Language",
          displayProperty: "owstaxIdEYKDLanguage",
          id: "language",
          dataType: "taxonomy"
        },
        {
          title: "Data Provider Type",
          displayProperty: "EYKDProviderType",
          id: "dataProviderType"
        },
        {
          title: "Data Delivery",
          displayProperty: "EYKDDataDelivery",
          id: "dataDelivery"
        },
      ],
      right: [
        {
          title: "Geo Access",
          displayProperty: "owstaxIdEYKDGeoAccess",
          id: "geoScope",
          dataType: "taxonomy"
        },
        {
          title: "Geo Scope",
          displayProperty: "owstaxIdEYKDGeoScope",
          id: "geoScope",
          dataType: "taxonomy"
        },
      ]
    }
  },
  relatedAssetsQuery: {
    sortList: [
      {
        Property: 'EYKDAssetType', Direction: 0
      }
    ]
  },
  manageCart: {
    maxItemsAddToCart: 100
  }

};

export default AppConfig;